<template>
  <div id="app" v-loading.fullscreen.lock="$store.state.app.globalLoading">
    <router-view />
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    // store.commit('setLoading', true);
  }
}
</script>
<style lang="less">
html,
body {
  background: #f8fafb;
  min-height: 680px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
